export const isIphoneX = (): boolean => {
  if (typeof window !== 'undefined') {
    return /iphone/gi.test(navigator?.userAgent) && window?.screen.height >= 812;
  }
};

export const isiOS = (): boolean => {
  if (typeof window !== 'undefined') {
    return Boolean(/iphone|ios|Mac OS/i.exec(navigator?.userAgent));
  }
};

export const isInApp = (): boolean => {
  if (typeof window !== 'undefined') {
    return Boolean(navigator?.userAgent?.match(/sharee|lemon/i));
  }
};
